<div class="bg-white rounded-10">
  <!-- Case loading -->
  @if (fetchComputed().isLoading) {
  <div class="mb-3 max-sm:mb-0 p-4 max-sm:p-3">
    <app-skeleton-details-standings />
  </div>
  }

  <!-- Case loaded -->
  @if(!fetchComputed().isLoading){

  <!-- Case loaded with data -->
  @if( this.getTeamStandings().length === 0) {
  <app-no-result message="NotAvalaibleInformation" />
  } @else {
  <div
    class="p-5 mb-3 text-center font-roboto-700 text-17 max-sm:mb-0 max-sm:text-14 max-sm:p-3"
  >
    {{ "Standing" | translate }}
  </div>

  <div nz-row>
    <div nz-col nzSpan="24" class="font-inter-500">
      <div class="flex flex-col gap-5">
        @for(stageStandings of this.getTeamStandings(); track $index) {
        <div class="flex flex-col gap-5">
          <div
            class="ml-2 text-start font-roboto-700 text-17 max-sm:mb-0 max-sm:text-14"
          >
            {{
              this.getNameTranslation(
                stageStandings.StageDescriptionTranslation,
                stageStandings.StageDescription ?? ""
              )
            }}
          </div>
          @for(groupTeams of stageStandings.GroupStandings; track $index) {

          <nz-table
            class="standings-table"
            #sortTable
            [nzData]="groupTeams.Teams!"
            [nzShowPagination]="false"
            [nzPageSize]="groupTeams.Teams!.length"
          >
            <thead>
              <tr>
                @for (column of this.listOfColumn; track $index) {
                <th
                  class="font-inter-600 !text-grey-2 !p-1 md:!p-4"
                  [nzShowSort]="column.show"
                  [nzSortFn]="column.compare"
                  [nzSortPriority]="column.priority"
                  nz-tooltip
                  [nzTooltipTitle]="column.tooltip | translate"
                  nzTooltipPlacement="top"
                  [nzLeft]="column.fixed"
                  [nzEllipsis]="true"
                  [nzAlign]="column.align === 0 ? 'left' : 'center'"
                  [nzWidth]="column.width"
                >
                  {{ column.title | translate }}
                </th>
                }
              </tr>
            </thead>
            <tbody>
              @for (data of sortTable.data; track $index) {
              <tr
                [routerLink]="data.Link"
                [class.bg-[#FFE4E5]]="higthLigth(data.Id)"
                [class.bg-white]="!higthLigth(data.Id)"
                (click)="handleInitTab()"
              >
                <td
                  class="!p-0 md:!p-4"
                  [ngStyle]="
                    data.PromotionColor && data.PromotionColor !== 'none'
                      ? { 'border-left': '4px solid ' + data.PromotionColor }
                      : {}
                  "
                >
                  <div
                    class="text-center mx-auto flex justify-center items-center rounded-full w-[23px] max-sm:w-[18px] text-white bg-red-2"
                  >
                    {{ data.Position }}
                  </div>
                </td>
                <td
                  [nzAlign]="'left'"
                  class="cursor-pointer text-black-3 !p-1 md:!p-4"
                  [class.bg-[#FFE4E5]]="higthLigth(data.Id)"
                  [class.bg-white]="!higthLigth(data.Id)"
                  nzLeft
                  [ngStyle]="{
                    'font-weight':
                      data.PromotionColor !== 'none' ? '900' : 'normal'
                  }"
                >
                  <div>
                    <div class="flex items-center w-full gap-3 max-w-32">
                      <img
                        alt="logoTeam"
                        class="h-[20px] w-[20px] aspect-video object-contain"
                        [src]="data.TeamLogo"
                      />
                      <p class="w-full">
                        <!-- <p class="truncate text-wrap"> -->
                        {{
                          this.getNameTranslation(
                            data.NameTranslation,
                            data.Name
                          )
                        }}
                      </p>
                    </div>
                  </div>
                </td>
                <td
                  [nzAlign]="'center'"
                  class="td-table bg-dark:bg-[#5A4D2D] text-black-3 !w-7 !p-1 md:!p-4"
                  [ngClass]="
                    higthLigth(data.Id)
                      ? 'bg-[#FFE4E5] dark:bg-[#FFE4E5]'
                      : 'bg-[#FFFAEC] dark:bg-[#5A4D2D]'
                  "
                >
                  {{ data.Played }}
                </td>
                <td
                  [nzAlign]="'center'"
                  class="td-table bg-[#ECF6EC] dark:bg-[#2F4432] text-red-2 dark:text-[#D97878] !w-7 !p-1 md:!p-4"
                  [ngClass]="
                    higthLigth(data.Id)
                      ? 'bg-[#FFE4E5] dark:bg-[#FFE4E5]'
                      : 'bg-[#ECF6EC] dark:bg-[#2F4432]'
                  "
                >
                  {{ data.Won }}
                </td>
                <td
                  [nzAlign]="'center'"
                  class="td-table text-red-2 dark:text-[#D97878] !p-1 md:!p-4"
                >
                  {{ data.Draw }}
                </td>
                <td
                  [nzAlign]="'center'"
                  class="td-table text-red-2 dark:text-[#D97878] !w-7 !p-1 md:!p-4"
                  [ngClass]="
                    higthLigth(data.Id)
                      ? 'bg-[#FFE4E5] dark:bg-[#FFE4E5]'
                      : 'bg-[#FFF3F3] dark:bg-[#4A2E2E]'
                  "
                >
                  {{ data.Loss }}
                </td>
                <td
                  [nzAlign]="'center'"
                  class="td-table text-black-3 !w-7 !p-1 md:!p-4"
                >
                  {{ data.GoalsDifference }}
                </td>
                <td
                  [nzAlign]="'center'"
                  class="td-table text-black-3 !w-7 !p-1 md:!p-4"
                  [width]="'30px'"
                >
                  {{ data.Points }}
                </td>
              </tr>
              }
            </tbody>
          </nz-table>
          }
        </div>
        }
      </div>
      @if(this.getPromotions() && this.getPromotions().length > 0) {
      <div class="flex flex-col gap-3 m-5 max-sm:m-3 max-sm:gap-1">
        @for( promotion of this.getPromotions(); track $index) {
        <div
          class="p-5 rounded-6 max-sm:p-2 max-sm:text-11"
          [ngStyle]="{
            'background-color': promotion.Color,
            color: promotion.TextColor ? promotion.TextColor : '#000'
          }"
        >
          {{
            this.getNameTranslation(promotion.NameTranslation, promotion.Name)
          }}
        </div>
        }
      </div>
      }
    </div>
  </div>
  } }
</div>
